'use client';

import { IconRightChevron } from "@/public/assets/icons/IconRightChevron";
import { Accordion, AccordionDetails, AccordionSummary, LinearProgress } from "@mui/material";
import styled from './ArchiveExpand.module.scss';
import {  useTransition } from "react";
import { usePathname, useRouter } from "next/navigation";
import { IconArchive } from "@/public/assets/icons/IconArchive";
import classNames from "classnames";



export function ArchiveExpand() {
  const [isPending, startTransition] = useTransition();
  const router = useRouter();
  const fullPathname = usePathname();
  const pathnameArchive = '/archive';
  const pathnameDocs = '/docs';
  const pathnameSessions = '/sessions';
  const title =  'Архив';
  async function handleSetPathname(path: string) {
    if (path === fullPathname) return;

    startTransition(() => {
      router.push(path);
    });
  }
  return (
    <Accordion className={styled.accordion} >
      <AccordionSummary
        className={styled.accordion_summary}
        sx={{
          minHeight: '30px',
          height: '30px',
          '&.Mui-expanded':{
            minHeight: '30px',
            height: '30px',
            marginBottom: '10px !important'
          },
          '&.MuiAccordionSummary-content':{
            margin: '0 !important'
          }
        }}
        expandIcon={<div style={{ transform: "rotate(-90deg)" }}><IconRightChevron width={"15px"} height={"15px"}/></div>}
        
      >
        <div className={styled.accordion_summary_box}>
          <IconArchive width={'20px'} height={'20px'}/>
          <div className={styled.accordion_title} style={{ color: [pathnameArchive, pathnameDocs, pathnameSessions].some(path => fullPathname.includes(path)) ? 'var(--sapphire-20)' : 'var(--steel-10)' }}>
            {title}
          </div>
        </div>
      </AccordionSummary>
      <AccordionDetails className={styled.accordion_body}>
        {isPending ? (<LinearProgress />) : (
          <>
            <button className={classNames(fullPathname.includes(pathnameArchive) ? styled.accordion_body_item_active : styled.accordion_body_item)} onClick={() => handleSetPathname(pathnameArchive)}>
              Подборка
            </button>
            <button className={classNames(fullPathname.includes(pathnameDocs) ? styled.accordion_body_item_active : styled.accordion_body_item)} onClick={() => handleSetPathname(pathnameDocs)}>
              Отчеты
            </button>
            <button className={classNames(fullPathname.includes(pathnameSessions) ? styled.accordion_body_item_active : styled.accordion_body_item)} onClick={() => handleSetPathname(pathnameSessions)}>
              Поисковые сессии
            </button>
          </>
        )}
       
      </AccordionDetails>
    </Accordion>
  );
}
